<template>
  <el-col class="chart-module" :lg="12" v-loading="loading">
    <div class="sub-view">
      <el-row>
        <span style="font-weight: bold">{{ displayTitle }}</span>
        <i
          class="el-icon-close"
          v-if="$root.editMode"
          @click="$root.onClose(title)"
        ></i>
        <i class="el-icon-zoom-in" v-else @click="showPopUp()"></i>
      </el-row>
      <el-row>
        <el-select
          v-model="period"
          @change="periodChange('main')"
          style="width: 30%; float: right; padding: 0"
        >
          <el-option
            v-for="item in periodOpthions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-row>
      <hr />
      <el-row>
        <echarts :autoresize="true" class="chart-view" :option="option" />
      </el-row>

      <el-dialog
        :visible.sync="popUpDisplay"
        :append-to-body="true"
        class="historyDailog"
      >
        <template slot="title">
          <el-row>
            <span style="font-weight: bold">{{ displayTitle }}</span>
            <el-row>
              <el-select
                v-model="period"
                @change="periodChange('popup')"
                style="width: 30%; padding: 0; float: right"
              >
                <el-option
                  v-for="item in periodOpthions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-row>
          </el-row>
        </template>
        <hr />
        <echarts
          :autoresize="true"
          :option="option"
          style="height: 75vh"
          v-loading="popupLoading"
        />
      </el-dialog>
    </div>
  </el-col>
</template>

<script>
import api from "@/api";
export default {
  name: "F2FStatusTimesChart",
  props: ["title", "displayTitle"],
  data() {
    return {
      periodOpthions: [
        {
          value: "①過去3ヶ月間の同月比",
          label: "①過去3ヶ月間の同月比",
        },
        {
          value: "②過去12ヶ月間の同月比",
          label: "②過去12ヶ月間の同月比",
        },
        {
          value: "③過去3年間の同月比",
          label: "③過去3年間の同月比",
        },
        {
          value: "④過去3年間の同年比",
          label: "④過去3年間の同年比",
        },
      ],
      period: "②過去12ヶ月間の同月比",
      endDate: this.$root.endDate,
      option: this.option,
      loading: this.loading,
      popupLoading: this.popupLoading,
      popUpDisplay: false,
    };
  },
  created() {
    let self = this;
    self.loading = true;
    api
      .getTelphoneStatusTimesCount("STAND_MIC_MODE", self.period, self.endDate)
      .then(
        (res) => {
          let data = res.data;
          self.option = {
            title: {
              right: "10%",
            },
            tooltip: {},
            calculable: true,
            barMaxWidth: "50%",
            grid: {
              top: 80,
              bottom: 80,
            },
            xAxis: [
              {
                type: "category",
                data: data.month_list,
                splitLine: {
                  show: false,
                },
              },
            ],

            yAxis: [
              {
                type: "value",
                name: "時間(分)",
              },
            ],
            series: data.output_list,
          };
          self.loading = false;
        },
        (err) => {
          console.log(err);
        }
      );
  },
  mounted() {
    this.$bus.$on("changeEndMonth", (startDate, endDate) => {
      this.endDate = endDate;
      this.periodChange("main");
    });
  },
  methods: {
    showPopUp() {
      this.popUpDisplay = true;
    },
    periodChange(value) {
      let self = this;
      if (value == "main") {
        self.loading = true;
      } else {
        self.popupLoading = true;
      }
      api
        .getTelphoneStatusTimesCount(
          "STAND_MIC_MODE",
          this.period,
          this.endDate
        )
        .then(
          (res) => {
            let data = res.data;
            self.option = {
              title: {
                right: "10%",
              },
              tooltip: {},
              calculable: true,
              barMaxWidth: "50%",
              grid: {
                top: 80,
                bottom: 80,
              },
              xAxis: [
                {
                  type: "category",
                  data: data.month_list,
                  splitLine: {
                    show: false,
                  },
                },
              ],

              yAxis: [
                {
                  type: "value",
                  name: "時間(分)",
                },
              ],
              series: data.output_list,
            };
            if (value == "main") {
              self.loading = false;
            } else {
              self.popupLoading = false;
            }
          },
          (err) => {
            console.log(err);
          }
        );
    },
  },
};
</script>
<style>
</style>
